import { Injectable } from '@angular/core';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MapService } from 'src/app/vehicles/services/map.service';
import { of, Subject } from 'rxjs';
import { delay, switchMap, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class PanelService {

  options = new Array(
  { id: 'GEOPOINTS', name: "PANEL.OPTIONS.GEOPOINTS.NAME", description: "PANEL.OPTIONS.GEOPOINTS.DESCRIPTION" },
  { id: 'HISTORIAL', name: "PANEL.OPTIONS.HISTORIAL.NAME", description: "PANEL.OPTIONS.HISTORIAL.DESCRIPTION" },
  { id: 'VEHICLES', name: "PANEL.OPTIONS.VEHICLES.NAME", description: "PANEL.OPTIONS.VEHICLES.DESCRIPTION" },
  { id: 'ALERTS', name: "PANEL.OPTIONS.ALERTS.NAME", description: "PANEL.OPTIONS.ALERTS.DESCRIPTION" },
  { id: 'ALERTS-GPS', name: "PANEL.OPTIONS.ALERTS-GPS.NAME", description: "PANEL.OPTIONS.ALERTS-GPS.DESCRIPTION" },
  { id: 'ALERTS-GPS-CREATE', name: "PANEL.OPTIONS.ALERTS-GPS-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-GPS-CREATE.DESCRIPTION" },
  { id: 'ALERTS-PLATFORMS', name: "PANEL.OPTIONS.ALERTS-PLATFORMS.NAME", description: "PANEL.OPTIONS.ALERTS-PLATFORMS.DESCRIPTION" },
  { id: 'ALERTS-PLATFORM-CREATE', name: "PANEL.OPTIONS.ALERTS-PLATFORM-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-PLATFORM-CREATE.DESCRIPTION" },
  { id: 'ALERTS-ACCESSORIES', name: "PANEL.OPTIONS.ALERTS-ACCESSORIES.NAME", description: "PANEL.OPTIONS.ALERTS-ACCESSORIES.DESCRIPTION" },
  { id: 'ALERTS-ACCESSORIE-CREATE', name: "PANEL.OPTIONS.ALERTS-ACCESSORIE-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-ACCESSORIE-CREATE.DESCRIPTION" },
  { id: 'ALERTS-SECURITY', name: "PANEL.OPTIONS.ALERTS-SECURITY.NAME", description: "PANEL.OPTIONS.ALERTS-SECURITY.DESCRIPTION" },
  { id: 'ALERTS-SECURITY-CREATE', name: "PANEL.OPTIONS.ALERTS-SECURITY-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-SECURITY-CREATE.DESCRIPTION" },
  { id: 'ALERTS-SECURITY-EDIT', name: "PANEL.OPTIONS.ALERTS-SECURITY-EDIT.NAME", description: "PANEL.OPTIONS.ALERTS-SECURITY-EDIT.DESCRIPTION" },
  { id: 'ALERTS-MOBILE', name: "PANEL.OPTIONS.ALERTS-MOBILE.NAME", description: "PANEL.OPTIONS.ALERTS-MOBILE.DESCRIPTION" },
  { id: 'ALERTS-MOBILE-CREATE', name: "PANEL.OPTIONS.ALERTS-MOBILE-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-MOBILE-CREATE.DESCRIPTION" },
  { id: 'ALERTS-MOBILE-EDIT', name: "PANEL.OPTIONS.ALERTS-MOBILE-EDIT.NAME", description: "PANEL.OPTIONS.ALERTS-MOBILE-EDIT.DESCRIPTION" },
  { id: 'ALERTS-360', name: "PANEL.OPTIONS.ALERTS-360.NAME", description: "PANEL.OPTIONS.ALERTS-360.DESCRIPTION" },
  { id: 'ALERTS-360-CREATE', name: "PANEL.OPTIONS.ALERTS-360-CREATE.NAME", description: "PANEL.OPTIONS.ALERTS-360-CREATE.DESCRIPTION" },
  { id: 'ALERTS-360-EDIT', name: "PANEL.OPTIONS.ALERTS-360-EDIT.NAME", description: "PANEL.OPTIONS.ALERTS-360-EDIT.DESCRIPTION" },
  { id: 'GEOFENCES', name: "PANEL.OPTIONS.GEOFENCES.NAME", description: "PANEL.OPTIONS.GEOFENCES.DESCRIPTION" },
  { id: 'CIRCULAR-GEOFENCE', name: "PANEL.OPTIONS.CIRCULAR-GEOFENCE.NAME", description: "PANEL.OPTIONS.CIRCULAR-GEOFENCE.DESCRIPTION" },
  { id: 'POLYLINE-GEOFENCE', name: "PANEL.OPTIONS.POLYLINE-GEOFENCE.NAME", description: "PANEL.OPTIONS.POLYLINE-GEOFENCE.DESCRIPTION" },
  { id: 'EVENT-USER', name: "PANEL.OPTIONS.EVENT-USER.NAME", description: "PANEL.OPTIONS.EVENT-USER.DESCRIPTION" },
  { id: 'USER-INFO', name: "PANEL.OPTIONS.USER-INFO.NAME", description: "PANEL.OPTIONS.USER-INFO.DESCRIPTION" },
  { id: 'USER-CONFIG', name: "PANEL.OPTIONS.USER-CONFIG.NAME", description: "PANEL.OPTIONS.USER-CONFIG.DESCRIPTION" },
  { id: 'DASHBOARD', name: "PANEL.OPTIONS.DASHBOARD.NAME", description: "PANEL.OPTIONS.DASHBOARD.DESCRIPTION" },
  { id: 'AUDITORIA', name: "PANEL.OPTIONS.AUDITORIA.NAME", description: "PANEL.OPTIONS.AUDITORIA.DESCRIPTION" },
  { id: 'SUBCUENTAS', name: "PANEL.OPTIONS.SUBCUENTAS.NAME", description: "PANEL.OPTIONS.SUBCUENTAS.DESCRIPTION" },
  { id: 'DRIVERS', name: "PANEL.OPTIONS.DRIVERS.NAME", description: "PANEL.OPTIONS.DRIVERS.DESCRIPTION" },
  { id: 'MULTIVIEW', name: "PANEL.OPTIONS.MULTIVIEW.NAME", description: "PANEL.OPTIONS.MULTIVIEW.DESCRIPTION" }
);

  nombreComponente: string = '';
  nombreCabecera: string = '';
  clasePanelActivo: string = '';

  userData: any; //Informacion del usuario

  private readonly renderizeMapSubject = new Subject<void>();
  private readonly renderizeMap$ = this.renderizeMapSubject.pipe(
    switchMap((_) => of(true).pipe(delay(800))),
    tap(() => {
      this.mapService.map.invalidateSize({ animate: true, duration: 0.3 });
    })
  );

  constructor(private http: HttpClient, private mapService: MapService, private translate : TranslateService) {
    this.renderizeMap$.subscribe();
  }

  clickShowPanel(nomComponent: string) {
    // console.log('-----clickShowPanel');
    /* console.log(this.activePanelClass()); */
    const isClosingPanel =
      this.nombreComponente == nomComponent ||
      this.nombreComponente.includes(nomComponent);

    if (isClosingPanel) {
      $('#panelMonitoreo').hide('slow');
      this.nombreComponente = '';

      this.renderizeMapSubject.next();
    } else {
      $('#panelMonitoreo').show('slow');
      this.nombreComponente = nomComponent;
      this.clasePanelActivo = this.activePanelClass();
      const item = this.options.filter((item) => item.id == nomComponent);
      this.nombreCabecera = item[0].name;

      this.renderizeMapSubject.next();
    }
  }

  clickHeaderToggle(nomComponent: string) {
    this.nombreComponente = nomComponent;
    const item = this.options.filter((item) => item.id == nomComponent);
    this.nombreCabecera = item[0].name;
  }

  activePanelClass() {
    switch (this.nombreComponente) {
      case 'VEHICLES':
        return 'vehiculos';
      case 'ALERTS':
      case 'ALERTS-GPS':
      case 'ALERTS-PLATFORMS':
      case 'ALERTS-ACCESSORIES':
      case 'ALERTS-SECURITY':
      case 'ALERTS-MOBILE':
      case 'ALERTS-360':
        return 'alertas';
      case 'GEOFENCES':
        return 'geocercas';
      case 'CIRCULAR-GEOFENCE':
        return 'circular-geofences';
      case 'POLYLINE-GEOFENCE':
        return 'polyline-geofences';
      case 'GEOPOINTS':
        return 'geopuntos';
      case 'HISTORIAL':
        return 'historial';
      case 'EVENT-USER':
        return 'notificaciones';
      case 'USER-INFO':
        return 'informacion';
      case 'USER-CONFIG':
        return 'configuracion';
      case 'DASHBOARD':
        return 'dashboard';
      case 'AUDITORIA':
        return 'auditoria';
      case 'SUBCUENTAS':
        return 'subcuentas';
      case 'DRIVERS':
        return 'drivers';
      case 'MULTIVIEW':
        return 'multiview';
      default:
        return '';
    }
  }

  getComponentNameFromPanelName(panelActive: string) {
    switch (panelActive) {
      case 'vehiculos':
        return 'VEHICLES';
      case 'alertas':
        return 'ALERTS';
      case 'geocercas':
        return 'GEOFENCES';
      case 'circular-geofences':
        return 'CIRCULAR-GEOFENCE';
      case 'polyline-geofences':
        return 'POLYLINE-GEOFENCE';
      case 'geopuntos':
        return 'GEOPOINTS';
      case 'historial':
        return 'HISTORIAL';
      case 'notificaciones':
        return 'EVENT-USER';
      case 'informacion':
        return 'USER-INFO';
      case 'configuracion':
        return 'USER-CONFIG';
      case 'dashboard':
        return 'DASHBOARD';
      case 'auditoria':
        return 'AUDITORIA';
      case 'subcuentas':
        return 'SUBCUENTAS';
      case 'drivers':
        return 'DRIVERS';
      case 'multiview':
        return 'MULTIVIEW';
      default:
        return '';
    }
  }

  public async activity_logout(user: any) {
    const response: ResponseInterface = await this.http
      .post<ResponseInterface>(`${environment.apiUrl}/api/logout`, user)
      .toPromise();
    return response.data;
  }
}
